module.exports = __webpack_public_path__ + "img/safety-tool-fmea-item1-1.7ee3717d.png";